import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatService } from '../../../services/chat.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-chat-head',
  templateUrl: './chat-head.component.html',
  styleUrls: ['./chat-head.component.scss']
})
export class ChatHeadComponent implements OnInit {
  @Input() title: string;
  @Output() deleteChatEvent = new EventEmitter<boolean>();
  @Output() callActive = new EventEmitter<boolean>();
  constructor(private chatService: ChatService) { }

  ngOnInit(): void {
  }

  deleteChat() {
    this.deleteChatEvent.emit(true);
  }

  back() {
    // @ts-ignore
    this.chatService.chatCurrent$.next(null);
  }

  call() {
    this.callActive.emit(true);
  }
}
